// extracted by mini-css-extract-plugin
export var fadeInOut = "_j-3";
export var icon = "_j-4";
export var savedIndicator = "_j-2";
export var savingIndicator = "_j-0";
export var spin = "_j-1";